import React from "react";
import PropTypes from "prop-types";
import { Button } from "@/components/ui/button";

export default function Steps({ steps }) {
  return (
    <nav aria-label="Progress">
      <ol role="list" className="space-y-4 md:flex md:space-y-0 md:space-x-8 mb-4">
        {steps.map((step) => (
          <li key={step.name} className="md:flex-1">
            {step.status === "complete" ? (
              <Button
                variant="ghost"
                onClick={step.onClick}
                className="cursor-pointer group w-full flex flex-col rounded-none border-l-4 border-blue-800 py-2 pl-4 hover:border-blue-800 md:border-l-0 md:border-t-4 md:pl-0 md:pt-4 md:pb-0"
              >
                <span className="text-xs font-semibold uppercase tracking-wide text-blue-800 group-hover:text-blue-800">
                  {step.id}
                </span>
                <span className="text-sm font-medium">{step.name}</span>
              </Button>
            ) : step.status === "current" ? (
              <Button
                variant="ghost"
                onClick={step.onClick}
                className="flex flex-col cursor-pointer w-full border-l-4 rounded-none hover:bg-white border-blue-800 py-2 pl-4 md:border-l-0 md:border-t-4 md:pl-0 md:pt-4 md:pb-0"
                aria-current="step"
              >
                <span className="text-xs font-semibold uppercase tracking-wide text-blue-800">
                  {step.id}
                </span>
                <span className="text-sm font-medium">{step.name}</span>
              </Button>
            ) : (
              <Button
                variant="ghost"
                onClick={step.onClick}
                className="cursor-pointer group flex w-full flex-col border-l-4 rounded-none hover:bg-white border-gray-200 py-2 pl-4 hover:border-gray-300 md:border-l-0 md:border-t-4 md:pl-0 md:pt-4 md:pb-0"
              >
                <span className="text-xs font-semibold uppercase tracking-wide text-gray-500 group-hover:text-gray-700">
                  {step.id}
                </span>
                <span className="text-sm font-medium">{step.name}</span>
              </Button>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}

Steps.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      status: PropTypes.oneOf(["upcoming", "current", "complete"]),
    }).isRequired,
  ).isRequired,
};
